<div class="wrap">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
      <h2>Liste des tags</h2>
    </div>
  </div>

  <div class="content">
    <div class="tag_categories">
      <div class="cache_category" *ngIf="updateColor"> </div>
      <div class="tag_categories_title">
        <h4>Catégories</h4>
        <div class="add_category" (click)="openDialogAddCategoryOrTag('categorie', 'Ajouter une catégorie', 'add')">
          <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
          <span>Ajouter une catégorie</span>
        </div>
      </div>

      <mat-radio-group>
        <mat-radio-button [color]="color" *ngFor="let t of tags; let i = index;"
          [checked]="t.tagTypeName === categorySelected.tagTypeName" [value]="t" (change)="changeTagCategory(t)">
          <span>{{ t.tagTypeName}}</span>
          <mat-slide-toggle [checked]="t.isActive"
            (change)="changeActiveStatusCategory(t, $event)"></mat-slide-toggle>
          <!-- <mat-slide-toggle [checked]="t.isActive" [color]="color"
            (change)="changeActiveStatusCategory(t, $event)"></mat-slide-toggle> -->
        </mat-radio-button>
      </mat-radio-group>

    </div>

    <div class="tags" *ngIf="!updateColor">
      <div class="tag_header">
        <div class="tag_selected">
          <div class="title">
            <h2>
              {{categorySelected?.tagTypeName}}
            </h2>
            <fa-icon [icon]="getFaIcon('faPen')" [matTooltip]="'Modifier'"
              (click)="openDialogAddCategoryOrTag('categorie', 'Modifier la catégorie', 'edit')"></fa-icon>

            <ul class="universeList">
              <li *ngFor="let universe of categorySelected?.universes; let i = index">
                {{universe.universeName}}
                <span *ngIf="i < categorySelected?.universes.length - 1">,&nbsp;</span>
              </li>
            </ul>
          </div>


          <div class="add_search_tag">
            <div class="add_tag" (click)="openDialogAddCategoryOrTag('tag', 'Ajouter un tag', 'add')">
              <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
              <span>Ajouter un tag</span>
            </div>
            <div class="search_bar">
              <form [formGroup]="searchForm">
                <input type="text" placeholder="Chercher un tag ..." (input)="applyFilter($event.target.value)"
                  formControlName="keyword">
              </form>

              <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes"
                *ngIf="valueInput"></fa-icon>
              <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>

            </div>
          </div>

        </div>

        <div class="colors">
          Gestion des couleurs
          <button (click)="updateColors()" appChangeColorTheme attribute="bgc">Modifier</button>
        </div>
      </div>


      <div class="table">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

          <ng-container matColumnDef="label">
            <mat-header-cell *matHeaderCellDef class="cell_text"> Label </mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell_text"> {{element.tagName}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="color">
            <mat-header-cell *matHeaderCellDef class="cell_text"> Couleur </mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell_text">
              <app-change-color-tag [tag]="element" (updateTag)="getTags(true)"></app-change-color-tag>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="active">
            <mat-header-cell *matHeaderCellDef class="cell_action"> Act./désac. </mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell_action">
              <mat-slide-toggle [checked]="element.isActive" [color]="color"
                (change)="changeActiveStatusTag(element, $event)"></mat-slide-toggle>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef class="cell_action"> Éditer </mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell_action">
              <fa-icon [icon]="getFaIcon('faPen')"
                (click)="openDialogAddCategoryOrTag('tag', 'Modifier le tag', 'edit', element)"></fa-icon>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </table>
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = $event" [color]="color">
        </mat-paginator>
      </div>
    </div>

    <div class="colors_update" *ngIf="updateColor">
      <div class="header">
        <h4>Liste des couleurs</h4>
        <button (click)="updateColors()">Retour</button>
      </div>
      <div cdkDropList cdkDropListOrientation="horizontal" class="list" (cdkDropListDropped)="drop($event)">
        <div class="box" *ngFor="let c of colors; let i = index" cdkDrag>
          <span class="color" [style.background-color]="'#' +c.value"></span>
          <span> {{i+1}}. {{c.name}}</span>

          <div class="box" *cdkDragPreview>
            <span class="color" [style.background-color]="'#' +c.value"></span>
            <span> {{i+1}}. {{c.name}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
